import React, { useState, useEffect } from "react";
import '../styles/other.css';
import '../styles/pages.css';
import Axios from 'axios';
import { Link, Navigate, useLocation } from "react-router-dom";
import { navigate } from "@reach/router";

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';

// import components
import RoundButton from '../components/RoundButton.js';
import ApplicationHistoryTile from '../tiles/ApplicationHistoryTile.js';
import ApplicationTile from '../tiles/ApplicationTile.js';
import ExpandButton from '../components/ExpandButton.js';
import ProjectApplicationsTile from '../tiles/ProjectApplicationsTile.js';

// import assets
import btn_back_gray from '../assets/btn_back_gray.png';
import background from '../assets/background.jpg';

class ProjectDetail extends React.Component {
    setActualSection = this.props.setActualSection;

    constructor(props) {
        super(props);

        this.state = {
            redirectTo: null,
            actualOpenedTile: "",
            mainProjectId: 0,
            note: "",
            applicationsData: ([{id: 2, user: "John Smith", status: "CTL approvement", amount: 5000},
                                {id: 2, user: "John Smith", status: "CTL approvement", amount: 5000},
                                {id: 2, user: "John Smith", status: "CTL approvement", amount: 5000},
                                {id: 2, user: "John Smith", status: "CTL approvement", amount: 5000},
                                {id: 2, user: "John Smith", status: "CTL approvement", amount: 5000}]),
        }

    }

    componentDidMount(){
        this.setState({ redirectTo: null });

        const pathname = this.props.location.pathname;
        var id = pathname.substring(pathname.lastIndexOf("/")+1);
        if(id.includes("?")){ id = id.substring(0, id.indexOf("?")); }
        if(Number.isInteger(Number(id)))this.setState({ mainProjectId: parseInt(id) });
        
        //this.loadData();
    }

    componentDidUpdate(prevProps, prevState) {
    }

    loadData = () => {
        this.setState({ applicationsData: [] });

        var getOnlyMyContacts = this.props.allOrMy == "my" ? 1 : 0;
        var url = '/api/cont/get?tp=1&my='+getOnlyMyContacts;
        Axios.get(url).then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            this.setState({ applicationsData: response.data.result });
        });
    }

    setActualOpenedTile = (tile) => {
        this.setState({ actualOpenedTile: tile });
    }

    render() {
        if (this.state.redirectTo) {
            return <Navigate to={this.state.redirectTo} />
        }
        return (
            <div className="verticalStack flex" style={{height: "calc(100vh - 80px)", overflowY: "scroll"}}>
                <div className="horizontalStackCenter universalTableListingBar">
                    <div className="horizontalStackCenter onHoverToOrange clickable" onClick={() => this.setState({ redirectTo: -1 })}>
                        <img src={btn_back_gray} style={{height: 14, marginRight: 7}} />
                        <span className="fontPoppinsRegular13Gray" style={{whiteSpace: "nowrap"}}>{"Return to Previous Page"}</span>
                    </div>
                </div>

                <div className="horizontalStack flex">
                    <div className="verticalStack flex" style={{position: "relative"}}>

                        {/* PROJECT TILE */}
                        <div className="universalLeftTileWithTable" style={{marginBottom: 20}}>

                            {/* FIRST PART OF TILE WITH BACKGROUND */}
                            <div className="flex" style={{flex: 1, height: 100, position: "relative"}}>

                                <div style={{width: "calc(100% + 40px)", backgroundColor: "var(--full-black)", height: "100%", position: "absolute", zIndex: 0, marginLeft: "-20px", marginTop: "-15px", borderRadius: "20px 20px 0px 0px"}}>
                                    <img style={{width: "100%", height: "100%", borderRadius: "25px 25px 0px 0px", objectFit: "cover", opacity: 1}} src={background}/>
                                </div>

                                <div className="horizontalStack" style={{height: "100%"}}>

                                    <div className="verticalStack flex" style={{zIndex: "0", height: "100%"}}>
                                        <div className="verticalStackCenter flex" style={{height: "100%", marginTop: "-20px"}}>
                                            <div className="horizontalStack" style={{height: "100%"}}>
                                                <div className="horizontalStackCenter" style={{minWidth: 50, height: "100%"}}>
                                                    <div className="flex"></div>
                                                    <div className="responsiveThreeDotsContainer">
                                                        <span className="fontPoppinsMedium30White responsiveThreeDots"><b>{"Online Influencer Studio"}</b></span>
                                                    </div>
                                                    <div className="flex"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {/* SECOND PART OF TILE ABOUT PROJECT */}
                            <div className="horizontalStack" style={{position: "relative", width: "100%"}}>

                                <div className="verticalStack" style={{flex: 1, minWidth: 50}}>
                                    <div className="flex"></div>
                                    <span className="fontPoppinsRegular13DarkGray">Country: <span className="fontPoppinsRegular13Gray">Croatia</span></span>
                                    <div style={{height: 10}}></div>
                                    <span className="fontPoppinsRegular13DarkGray">Priority: <span className="fontPoppinsRegular13Gray">High</span></span>
                                    <div className="flex"></div>
                                </div>

                                <div className="verticalStack" style={{flex: 1, minWidth: 50}}>
                                    <div className="flex"></div>
                                    <span className="fontPoppinsRegular13DarkGray">Created Date: <span className="fontPoppinsRegular13Gray">8th December 2023</span></span>
                                    <div style={{height: 10}}></div>
                                    <span className="fontPoppinsRegular13DarkGray">Created By: <span className="fontPoppinsRegular13Gray">John Smith</span></span>
                                    <div className="flex"></div>
                                </div>

                                <div className="flex"></div>

                            </div>

                            <div className="horizontalStack" style={{marginTop: 10}}>
                                <ExpandButton isOpen={this.state.toolOpened} style={{marginTop: 5}} onClick={this.openCloseTool} />
                            </div>

                        </div>

                        <ProjectApplicationsTile applicationsData={this.state.applicationsData} isOpen={this.state.actualOpenedTile == "conversations" ? true : false} setActualOpenedTile={this.setActualOpenedTile} openAlertMessageTwoActions={this.props.openAlertMessageTwoActions} />


                    </div>

                </div>
            </div>
        );
    }
}

const withLocation = Component => props => {
    const location = useLocation();

    return <Component {...props} location={location} />;
};

export default withLocation(ProjectDetail);
